import { render, staticRenderFns } from "./wt-native-scroller.vue?vue&type=template&id=71598d65"
import script from "./wt-native-scroller.vue?vue&type=script&lang=js"
export * from "./wt-native-scroller.vue?vue&type=script&lang=js"
import style0 from "./wt-native-scroller.vue?vue&type=style&index=0&id=71598d65&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports